<template>
  <div class="c-modal">
    <div class="c-modal__backdrop" @click="onClose('outside')"></div>

    <div class="c-modal__dialog" :class="[`c-modal__dialog--${size}`, {'c-modal__dialog--is-scrollable': isScrollable}]">
      <div class="c-modal__content">
        <div class="c-modal__header">
          <div class="c-modal__title">
            {{ title }}
          </div>
          <base-button v-if="canShowClose" class="c-modal__close" variant="link" :icon-append="['fal', 'times']" @click="onClose('x')" />
        </div>
        <div class="c-modal__body" ref="content" tabindex="-1" :style="bodyStyle">
          <slot />
        </div>
        <div class="c-modal__footer">
          <slot name="modal-footer" v-bind="{ ok: onOk, cancel: onCancel, hide: onHide, close: onClose }"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { event } from '@/mixins/helpers'

const defaultCloseOptions = ['escape', 'outside', 'x', 'close']

export default {
  name: 'BaseModal',

  props: {
    title: {
      type: String,
      required: true
    },
    canClose: {
      type: [Array, Boolean],
      default: () => { return defaultCloseOptions }
    },
    isScrollable: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'xxl',
      validator: value => ['sm', 'md', 'lg', 'xl', 'xxl'].includes(value)
    },
    minHeight: {
      type: [String, Number],
      required: false
    }
  },

  mixins: [event],

  mounted () {
    this.$nextTick(() => {
      this.$refs.content.focus()
    })
  },

  computed: {
    closeOptions () {
      return typeof this.canClose === 'boolean' ? this.canClose ? defaultCloseOptions : [] : this.canClose
    },
    canShowClose () {
      return this.closeOptions.includes('x')
    },
    events () {
      return [{ name: 'keyup', handler: this.onKeyUp }]
    },
    bodyStyle () {
      return {
        minHeight: this.minHeight + 'px'
      }
    }
  },

  methods: {
    onOk () {
      this.hide('ok')
    },
    onCancel () {
      this.hide('cancel')
    },
    onHide () {
      this.hide('hide')
    },
    onClose (method = 'close') {
      if (this.closeOptions.includes(method)) {
        this.hide('close', { method })
      }
    },
    onKeyUp (event) {
      if (event.keyCode === 27) {
        this.onClose('escape')
      }
    },
    hide (trigger, args) {
      const event = { preventDefault: function () { this.defaultPrevented = true }, defaultPrevented: false, ...args }

      this.$emit(trigger, event)

      if (event.defaultPrevented === false) {
        this.$nextTick(() => {
          this.$emit('hidden', arguments)
        })
      }
    }
  }
}
</script>
